import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import panther from '../../images/panther.png';
import useAchievements from './useAchievements';
import AchievementHeader from './AchievementHeader';
import AchievementGrid from './AchievementGrid';
import './achievements.css';

export default function AchievementsScreen() {
  const navigate = useNavigate();
  const { achievements, completed, total, points } = useAchievements();

  return (
    <div className="glass-scope ach-page">
      <div className="gd-head ach-top">
        <button type="button" className="ach-back" onClick={() => navigate(-1)} aria-label="Back">
          <ArrowLeftOutlined />
        </button>
        <h1>Achievements</h1>
      </div>

      <div className="ach-hero">
        <div className="ach-hero__ring"><img src={panther} alt="Lincfolio mascot" /></div>
        <p>Unlock exclusive badges by improving your trading discipline and consistency.</p>
      </div>

      <AchievementHeader completed={completed} total={total} points={points} />
      <AchievementGrid achievements={achievements} />
    </div>
  );
}